export const tutorialMessages = {
  1: {
    text: "Welcome to NeuSort. Do you like to continue with the tutorial?",
    showNext: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      tooltipHeight: 180,
      offsetY: 10,
    },
  },
  2: {
    text: "This is the Dashboard Pro. Click to manage your workspace.",
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 350,
      offsetY: 10,
    },
  },
  3: {
    text: "Click here to create a new interview.",
    showSkip: true,
    positionConfig: {
      type: "left-align",
      tooltipWidth: 270,
      offsetY: 10,
    },
  },
  4: {
    text: "Click to autofill the form with sample data.",
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  5: {
    text: "Paste your job description here. Once you start typing, we'll guide you next.",
    showNext: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  6: {
    text: "Click to autofill to generate the form with sample data.",
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  7: {
    text: "Enter the Job Role for the position.",
    showNext: true,
    showSkip: true,
    positionConfig: {
      type: "left",
      tooltipWidth: 350,
      offsetX: -280,
    },
  },
  8: {
    text: "Select relevant Tech Stack.",
    showNext: true,
    showSkip: true,
    positionConfig: {
      type: "left",
      tooltipWidth: 350,
      offsetX: -230,
    },
  },
  9: {
    text: "Choose candidate skills.",
    showNext: true,
    showSkip: true,
    positionConfig: {
      type: "left",
      tooltipWidth: 350,
      offsetX: -230,
    },
  },
  10: {
    text: "Pick years of experience.",
    showSkip: true,
    showPrev: true,
    positionConfig: {
      type: "left",
      tooltipWidth: 350,
      offsetX: -250,
    },
  },
  11: {
    text: "Add at least one test from the list. If you want to add a custom test, note that it will be a paid feature.",
    showNext: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  12: {
    text: "Download the sample candidate file using the download button provided.",
    showSkip: true,
    showPrev: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  13: {
    text: "Upload the filled candidate list file to proceed.",
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  14: {
    text: "Review and verify all information before submission.",
    showNext: true,
    showSkip: true,
    showPrev: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  15: {
    text: "Check your selected settings and ensure everything is correct.",
    showNext: true,
    showPrev: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  16: {
    text: "Check your selected settings and ensure everything is correct.",
    showNext: true,
    showPrev: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  17: {
    text: "Check your selected settings and ensure everything is correct.",
    showNext: true,
    showPrev: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  18: {
    text: "Check your selected settings and ensure everything is correct.",
    showNext: true,
    showPrev: true,
    showSkip: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
  19: {
    text: "Submit the form to finalize the interview creation.",
    showPrev: true,
    showSkip: true,
    showFinish: true,
    positionConfig: {
      type: "below",
      tooltipWidth: 400,
      offsetY: 10,
    },
  },
};